import { POST_CONTRACTED_HOURS_SUCCESS, POST_CONTRACTED_HOURS_FAILURE } from "../constants/MyM";
import { postApi } from "../../utils/apiCall";

const postContractedHoursSuccess = (data) => {
  return {
    type: POST_CONTRACTED_HOURS_SUCCESS,
    payload: data,
  };
};

const postContractedHoursFailure = (data) => {
  return {
    type: POST_CONTRACTED_HOURS_FAILURE,
    payload: data,
  };
};

export const postContractedHours = (data) => {
  return async (dispatch, getState) => {
    const { error, result } = await postApi(`/manage_facility_contract_hours`, {
      ...data,
    });
    if (!error) {
      return dispatch(postContractedHoursSuccess(result));
    }
    return dispatch(postContractedHoursFailure(result));
  };
};
